import { z } from "zod";

export const machineStopReasonSchema = z.object({
	stopCode: z.number(),
	message: z.string(),
	arguments: z.array(z.number()),
	isError: z.boolean(),
});

export type MachineStopReason = z.infer<typeof machineStopReasonSchema>;
